/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_Switch_To_LoginInputs */

const en_funnel_account_switch_to_login = /** @type {(inputs: Funnel_Account_Switch_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in instead`)
};

const es_funnel_account_switch_to_login = /** @type {(inputs: Funnel_Account_Switch_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión en su lugar`)
};

/**
* | output |
* | --- |
* | "Sign in instead" |
*
* @param {Funnel_Account_Switch_To_LoginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_switch_to_login = /** @type {((inputs?: Funnel_Account_Switch_To_LoginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_Switch_To_LoginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_switch_to_login(inputs)
	return en_funnel_account_switch_to_login(inputs)
});